import React, {useRef, useState} from "react";
import styled from "styled-components";
import {
    LinkedInImage, LinkedInImageBlue,
    LinkedInNameBar,
    NameText,
    TextHolder,
    YouAreBookingWithText
} from "../CalendarPage/styled";
import MeetingConfirmedImage from '../../../assets/images/meetingconfirmed2.png'
import {createStructuredSelector} from "reselect";
import * as selectors from "../../../selectors";
import * as globalActions from "../../../actions";
import {connect} from "react-redux";
import {getFullBookedDate, getFullBookedTime, getFullBookedTimeDetails, months, weeks} from "../CalendarPage/utils";
import ZoomLogo from '../../../assets/icons/zoom.svg';
import GoogleMeetLogo from '../../../assets/icons/google-meet.svg';
import MicrosoftTeamsLogo from '../../../assets/icons/microsoft-teams.svg';
import LocationLogo from '../../../assets/icons/location.svg';
import ZIAvatar from "../../components/ZIAvatar";
import LinkedInIcon from "../../../assets/icons/LinkedInIcon.png";
import LinkedInIconBlue from "../../../assets/icons/LinkedInIconBlue.png";
import {DEVICE_WIDTH} from "../../../common/constants";
import TimeBar from "../../components/TimeBar";
import BackIcon from "../../../assets/icons/back.svg";
import {EnterDetailsPageContainer} from "../EnterDetailsPage";
import {ReactComponent as MeetingConfirmedLogoSvg} from '../../../assets/images/meetingConfirmed.svg'
import {MeetingDescription} from '../CalendarPage'

const FullBookedDateContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
`

const MeetingConfirmedTitleContainer = styled.div`
  border-bottom: 1px solid #D9DDE4;
  margin-bottom: 16px;
`

const FullBookedDateDiv = styled.div`
  width: max-content;
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 16px;
  display:flex;
  align-items: center;
  line-height: 24px;
  &:after{
    content: '';
    border: 1px solid #A3AEBF;
    height: 66%;
    display: inline-block;
    margin-left: 7px;
  }
`;

const FullBookedDayDiv =styled.div`
  font-family: "Poppins" !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding-left: 8px;
  color: #525F76;

`;

const FullBookedTimeDiv = styled.div`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #525F76;
`

export const MeetingConfirmedPageContainer = styled.div`
  width: 434px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-right: ${p => p.separator?'1px solid #E5E7EC':''};
  @media(max-width: ${DEVICE_WIDTH.MOBILE}px){
    margin-top: 90px;
    width: unset;
  }
  @media(min-width: 428px){
    padding-bottom: 80px;
  }
`;

const BookedTimeContainer = styled.div`
  font-family: "Poppins" !important;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  line-height: 22px;
  color: #525F76;
  text-align: start;
  margin-bottom: 16px;
  margin-right: 10px;
  margin-left: ${p => p.isIframe ? '12px' : '0'};
`;

const MeetingConfirmedLogo = styled.img`
  width: 306.54px;
  @media (max-width: ${DEVICE_WIDTH.MOBILE}px){
    width: 278px;
  }
`;

const MeetingConfirmedLogoIframe =styled.img`
  width: 85px;
  height: 65.18px;
`;

const ZoomImage = styled.img`
  width: 22.56px;
  height: 24px;
  margin-right: 8.44px;
`;

const MeetingConfirmedHeaderTitle = styled.div`
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #0061FF;
  text-align: left;
  margin-bottom: ${p => p.isIframe ? '0' : '4px'};
  margin-top: ${p => p.isIframe ? '4px' : '0'};
  margin-left: ${p => p.isIframe ? '-16px' : '0'};
  @media (max-width: ${DEVICE_WIDTH.MOBILE}px){
    max-width: calc(100vw - 96px)
  }
`

const MeetingConfirmedTitle = styled.div`
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #12151A;
  text-align: left;
  margin-bottom: 4px;
`;

const MeetingConfirmedContainer = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(140, 142, 159, 0.2);
  border-radius: 10px;
  padding: 24px;
  width: 386px;
  @media (max-width: ${DEVICE_WIDTH.MOBILE}px){
    width: calc(100vw - 96px)
  }
`

const MeetingLinkContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

const MeetingLinkText = styled.a`
  font-size: 12px;
  line-height: 20px;
  color: #0061FF;
  text-decoration:none;
  cursor: pointer;
  word-break: break-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 24px;
`;

const AvatarBar = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${p => p.isIframe ? '0px' : '16px'};
  margin-left: ${p => p.isIframe ? '12px' : '0'};
  margin-top: 16px;
  cursor: pointer;
  width: max-content;
  &:hover ${NameText}{
    color: #0061FF;
  }
  &:hover ${LinkedInImage}{
    display: none;
  }
  &:hover ${LinkedInImageBlue}{
    display: block;
  }
`;

const MeetingConfirmedHeaderSubTitle = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: #525F76;
  margin-bottom: 22px;
`

const MeetingConfirmedHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
`;

const RightSideCardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${p => p.isIframe && p.isMeetingConfirmedPage ? 'column-reverse' : 'column'};
  @media screen and (min-width: 428px) {
    margin-left: 42px;
  }
  @media screen and (max-width: ${DEVICE_WIDTH.MOBILE}px) {
    padding: 0 4px 0 36px;
    width: calc(100vw - 48px);
  }
`;


const MeetingConfirmedTextHeader = styled.div`
  font-family: "Poppins" !important;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: #12151A;
  text-align: left;
  margin-bottom: 4px;
  margin-top: ${p => p.isIframe ? '4px' : '0'};
  margin-left: ${p => p.isIframe ? '-16px' : '0'};
  @media (max-width: ${DEVICE_WIDTH.MOBILE}px){
    max-width: calc(100vw - 96px)
  }
`;

const LeftSideCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  visibility: ${p => p.isTimezoneLoading ? "hidden" : "visible"};
  padding-right: ${p => p.isIframe ? '11px' : '32px'};
  border-right: ${p => p.separator?'1px solid #E5E7EC':''};
  @media screen and (min-width: 428px) {
    max-width: 414px;
    ${p => p.page==="calendar" && !p.isIframe ? 'min-height: 346px;':''}
  }
  @media screen and (max-width: ${DEVICE_WIDTH.MOBILE}px) {
    border-right: none;
    padding: 24px 20px 24px 24px;
    width: calc(100vw - 50px);
  }
`;

export const CalendarTitle = styled.div`    
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #12151A;
  margin: 0 10px 10px 0;
  text-align: left;
  @media screen and (min-width: 428px) {
    width: 414px;
  }
`;

export const DescriptionBar = styled.div`
  font-family: "Poppins" !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #525F76;
  text-align: start;
  width: fit-content;
  margin: ${p => p.margin ? p.margin : "10px 0 8px 0"};
  white-space: pre-wrap;
  max-height: ${p => p.isProspectAvailable ? "154px" : "126px"};
  overflow-y: auto;
  &::-webkit-scrollbar-thumb {
    background-color: #7585A0;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #E5E7EC;
    border-radius: 12px;
  }
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
`;

const MeetingConfirmedPage = props => {
    const {
        meetingDetails,
        isIframe,
        clockSettings,
        captchaToken,
        timeZoneString
    } = props;
    let [leftSideContainerRef, setLeftSideContainerRef] = useState(null);
    const meeting = meetingDetails && meetingDetails.meeting;
    const user = meetingDetails && meetingDetails.user;
    let offset = meeting && meeting.offset;
    let timestamp = meeting && meeting.startTime;
    let date = timestamp && new Date((timestamp + offset) * 1000);
    let actualDate = timestamp && new Date((timestamp + offset + date.getTimezoneOffset()*60) * 1000);
    let endDate = meeting && meeting.endTime && new Date((meeting.endTime + offset) * 1000);
    const fullWeeks = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const fullMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let activeSlot = {
        date: actualDate.getDate() < 10 ? '0' + actualDate.getDate() : actualDate.getDate(),
        day: weeks[date.getDay()],
        month: months[date.getMonth()],
        fullMonth: fullMonths[date.getMonth()],
        fullDay: fullWeeks[date.getDay()],
        year: date.getFullYear(),
        timestamp: parseInt(timestamp),
    }
    let activeSlotTime = date.getUTCHours() * 3600 + date.getUTCMinutes() * 60 + date.getUTCSeconds();
    let endTime = endDate.getUTCHours() * 3600 + endDate.getUTCMinutes() * 60 + endDate.getUTCSeconds();
    let meetingProvider = meeting && meeting.conferenceProvider;
    let meetingLink = meeting && meeting.meetingLink;
    let calendarTitleRef = useRef(null);
    let timeBarRef = useRef(null);
    let descriptionBarRef = useRef(null);
    let avatarBarRef = useRef(null);
    let bookedTimeContainerRef = useRef(null);
    let backButtonRef = useRef(null);
    let leftSideCardContainerRef = useRef(null);
    let location = meeting && meeting.location;

    return isIframe ? (
        <EnterDetailsPageContainer>
            <LeftSideCardContainer isIframe={isIframe} separator={true} ref={newRef => setLeftSideContainerRef(newRef)}>
                <CalendarTitle ref={calendarTitleRef}>{meeting.subject}</CalendarTitle>
                {meeting.description && <MeetingDescription ref={descriptionBarRef}>{meeting.description}</MeetingDescription>}
                <AvatarBar onClick={ () => {if (user?.linkedinUrl) window.open(user?.linkedinUrl, "_blank")} } ref={avatarBarRef}>
                    <ZIAvatar img={user?.avatar} name={user?.name}/>
                    <TextHolder>
                        <YouAreBookingWithText>You are booking with</YouAreBookingWithText>
                        <LinkedInNameBar>
                            <NameText>{user?.name}</NameText>
                            {user?.linkedinUrl && <LinkedInImage src={LinkedInIcon} />}
                            {user?.linkedinUrl && <LinkedInImageBlue src={LinkedInIconBlue} />}
                        </LinkedInNameBar>
                    </TextHolder>
                </AvatarBar>
                <BookedTimeContainer>
                    <FullBookedDateContainer>
                        <FullBookedDateDiv>{getFullBookedDate(activeSlot, activeSlotTime)}</FullBookedDateDiv>
                        <FullBookedDayDiv>{activeSlot.fullDay}</FullBookedDayDiv>
                    </FullBookedDateContainer>
                    <FullBookedTimeDiv>{getFullBookedTime(activeSlot, activeSlotTime, endTime, clockSettings?clockSettings.clockSettings:12)}</FullBookedTimeDiv>
                </BookedTimeContainer>
                <MeetingLinkContainer isIframe={isIframe}>
                    {meetingProvider === "teamsForBusiness" && <ZoomImage src={MicrosoftTeamsLogo} />}
                    {meetingProvider === "hangoutsMeet" && <ZoomImage src={GoogleMeetLogo} />}
                    {meetingProvider === "custom" && <ZoomImage src={LocationLogo} />}
                    {(meetingProvider === "zoom" && meetingLink) && <ZoomImage src={ZoomLogo} />}
                    <MeetingLinkText onClick={ () => {if(meetingProvider !== "custom") window.open(meetingLink, "_blank")} }>{(meetingProvider === "custom" ? location : meetingLink)}</MeetingLinkText>
                </MeetingLinkContainer>
            </LeftSideCardContainer>
            <RightSideCardContainer isIframe={isIframe} ref={leftSideCardContainerRef}>
                <MeetingConfirmedLogoSvg style={{marginBottom: "8px"}}/>
                <MeetingConfirmedTextHeader isIframe={isIframe}>Meeting Confirmed!</MeetingConfirmedTextHeader>
                <MeetingConfirmedHeaderSubTitle>A calendar invite has been sent to your email</MeetingConfirmedHeaderSubTitle>
            </RightSideCardContainer>
        </EnterDetailsPageContainer>

    ) : (
        <EnterDetailsPageContainer>
            <LeftSideCardContainer separator={true}>
                <MeetingConfirmedTitle isIframe={isIframe}>{meeting.subject}</MeetingConfirmedTitle>
                <TimeBar noPopup={true} duration={meeting.endTime - meeting.startTime} timezone={timeZoneString} timeBarRef={timeBarRef} />
                {meeting.description && <MeetingDescription isIframe={isIframe} margin={"8px 0 8px 0"}>{meeting.description}</MeetingDescription>}
                <AvatarBar onClick={ () => {if (user?.linkedinUrl) window.open(user?.linkedinUrl, "_blank")} } isIframe={isIframe}>
                    <ZIAvatar img={user?.avatar} name={user?.name}/>
                    <TextHolder>
                        <YouAreBookingWithText>Meeting scheduled with</YouAreBookingWithText>
                        <LinkedInNameBar>
                            <NameText>{user?.name}</NameText>
                            {user?.linkedinUrl && <LinkedInImage src={LinkedInIcon} />}
                            {user?.linkedinUrl && <LinkedInImageBlue src={LinkedInIconBlue} />}
                        </LinkedInNameBar>
                    </TextHolder>
                </AvatarBar>
                <BookedTimeContainer>
                    <FullBookedDateContainer>
                        <FullBookedDateDiv>{getFullBookedDate(activeSlot, activeSlotTime)}</FullBookedDateDiv>
                        <FullBookedDayDiv>{activeSlot.fullDay}</FullBookedDayDiv>
                    </FullBookedDateContainer>
                    <FullBookedTimeDiv>{getFullBookedTime(activeSlot, activeSlotTime, endTime, clockSettings?clockSettings.clockSettings:12)}</FullBookedTimeDiv>
                </BookedTimeContainer>
                <MeetingLinkContainer isIframe={isIframe}>
                    {meetingProvider === "teamsForBusiness" && <ZoomImage src={MicrosoftTeamsLogo} />}
                    {meetingProvider === "hangoutsMeet" && <ZoomImage src={GoogleMeetLogo} />}
                    {meetingProvider === "custom" && <ZoomImage src={LocationLogo} />}
                    {(meetingProvider === "zoom" && meetingLink) && <ZoomImage src={ZoomLogo} />}
                    <MeetingLinkText onClick={ () => {if(meetingProvider !== "custom") window.open(meetingLink, "_blank")} }>{(meetingProvider === "custom" ? location : meetingLink)}</MeetingLinkText>
                </MeetingLinkContainer>
            </LeftSideCardContainer>

            <RightSideCardContainer isIframe={isIframe} ref={leftSideCardContainerRef}>
                <MeetingConfirmedLogoSvg style={{marginBottom: "8px"}}/>
                <MeetingConfirmedTextHeader isIframe={isIframe}>Meeting Confirmed!</MeetingConfirmedTextHeader>
                <MeetingConfirmedHeaderSubTitle>A calendar invite has been sent to your email</MeetingConfirmedHeaderSubTitle>
            </RightSideCardContainer>
        </EnterDetailsPageContainer>
    );
}

export const mapStateToProps = (state, props) => {
    return createStructuredSelector({
        meetingDetails: selectors.makeSelectMeetingDetails(),
        captchaToken: selectors.makeSelectCaptchaToken(),
        timeZoneString: selectors.makeSelectTimeZoneString(),
    });
};

export const mapDispatchToProps = dispatch => {
    return {
        setPage: payload => dispatch(globalActions.setPage(payload)),
        getMeetingDetails: () => dispatch(globalActions.getMeetingDetails.start())
    };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(MeetingConfirmedPage);